const o = {
  id: "ColoradoLotto",
  logo: !0,
  name: "Lotto+",
  style: {
    colorPrimary: "#00c0f3"
  }
};
export {
  o as default
};
